import { Component, Input } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { ModalListDataComponent } from '../modal-list-data/modal-list-data.component';

@Component({
  selector: 'app-survey-modal',
  templateUrl: './survey-modal.component.html',
  styleUrls: ['./survey-modal.component.scss']
})
export class SurveyModalComponent {
  @Input() title;
  @Input() singularTitle;
  @Input() plural;
  @Input() description;
  @Input() buttonText;
  @Input() hasItemForm = false;
  @Input() listedData;
  public root = ModalListDataComponent;

  constructor(private modalController: ModalController) {}

  async closeModal() {
    await this.modalController.dismiss();
  }
}
